<template>
    <div>
        <h1>About Page</h1>
        <p>Esta es la página acerca de.</p>
    </div>
</template>

<script>
export default {
    name: 'About',
};
</script>